
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';


export const DecimalFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: number,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const [error, setError] = useState(false);

  //number of digits left and right if the comma
  const numberDigitsRight = layoutField.ReferencedField_sys.Scale_sys
  const numberDigitsLeft = layoutField.ReferencedField_sys.Precision_sys - numberDigitsRight

  const stepSize = 10**(-numberDigitsRight);
  const maxValue = 10**numberDigitsLeft - stepSize;

  const handleChange = (event: any) => {
    const value = event.target.value;

    onChange(value, layoutField);
  }


  return (
      <TextField
         fullWidth
         error={false}
         disabled={layoutField.AccessSetting_sys === 'read'}
         size="small"
         label={`${layoutField.ReferencedField_sys.Label_sys}`}
         variant="filled"
         type="number"
         value={value}
         onChange={(event) => handleChange(event)}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         InputProps={{
           inputProps: {type: 'number',
                        step: stepSize,
                        min: -maxValue,
                        max: maxValue
                      },
          }}
      />

    );

};
